import './flare-network.css'

export default function FlareNetwork() {
  return (
    <div className="flare_container bg-[#efefef] py-24 sm:py-32">
      <div className="mx-auto max-w-7xl flex flex-col text-center items-center px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:mx-0">
          <h2 className="text-2xl font-semibold tracking-tight text-pretty text-gray-900 sm:text-3xl">
            The Flare Network
          </h2>
        </div>
        <div className="mx-auto mt-16 grid  grid-cols-1 gap-x-8 gap-y-16 text-base/7 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:grid-cols-4">
          <div className='aos-init aos-animate' data-aos="fade-up">
            <h4 className="text-lg font-semibold tracking-tight text-pretty text-gray-900 sm:text-xl">
              XRP End Game
            </h4>
            <iframe
              width="250"
              height="250"
              className="mt-2"
              src="https://www.youtube.com/embed/sFX1d7Si3mA"
              title="$10,000 Ripple XRP End Game"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </div>

          <div className='aos-init aos-animate' data-aos="fade-up">
            <h4 className="text-lg font-semibold tracking-tight text-pretty text-gray-900 sm:text-xl">
              New World Reserve Cryptocurrency Incoming! - Powered By Ripple
              (XRP){" "}
            </h4>

            <iframe
              width="250"
              height="250"
              className="mt-2"
              src="https://www.youtube.com/embed/yLeji6EidI8"
              title="Carney: A new virtual currency could ease reliance on US dollar"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </div>

          <div className='aos-init aos-animate' data-aos="fade-up">
            <h4 className="text-lg font-semibold tracking-tight text-pretty text-gray-900 sm:text-xl">
              Interview with Mark Philips{" "}
            </h4>

            <iframe
              width="250"
              height="250"
              className="mt-2"
              src="https://www.youtube.com/embed/juUgJwBwgWk"
              title="Ripple XRP   XRP Army News Welcomes Mark Phillips"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
            />
          </div>

          <a href="https://www.youtube.com/channel/UCHACcQVpw_p0n03zZdSt4fg/videos" className='aos-init aos-animate' data-aos="fade-up">
            <h4 className="text-lg font-semibold tracking-tight text-pretty text-gray-900 sm:text-xl">
              Follow Us on YOUTUBE{" "}
              <span className="text-orange-500">XRPQFSTeam1</span>
            </h4>

            <img
              src="/channel.png"
              alt="Youtube"
              width={250}
              height={250}
            />
          </a>
        </div>
      </div>
    </div>
  );
}
